/* =========================================================
   Teslimat geri sayımı — PDP. Kargo kesim saatine kalan süre
   ve tahmini kargo/teslimat tarihleri.

   Saat mağazanın saat dilimine (Europe/Istanbul) göre hesaplanır:
   müşteri yurt dışındaysa bile kesim saati Türkiye saatidir.
   ========================================================= */
(function () {
  "use strict";

  var TZ = "Europe/Istanbul";
  var timer = null;

  var strings = (window.theme && window.theme.strings) || {};

  /* Verilen anın Istanbul saatine göre parçaları. Intl kullanılıyor ki
     yaz saati / ofset değişikliği elle kodlanmasın. */
  function istanbulParts(date) {
    var fmt = new Intl.DateTimeFormat("en-GB", {
      timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit",
      hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false
    });
    var out = {};
    fmt.formatToParts(date).forEach(function (p) {
      if (p.type !== "literal") out[p.type] = parseInt(p.value, 10);
    });
    /* hour12:false bazı sürümlerde 24 döndürüyor */
    if (out.hour === 24) out.hour = 0;
    return out;
  }

  /* Istanbul takviminde "bugün"ü temsil eden, saat bilgisi taşımayan tarih.
     UTC tabanlı üretilir ki gün ekleme işlemleri yaz saatinden etkilenmesin. */
  function istanbulToday(now) {
    var p = istanbulParts(now);
    return new Date(Date.UTC(p.year, p.month - 1, p.day));
  }

  function addDays(day, count) {
    return new Date(day.getTime() + count * 86400000);
  }

  function isWorkday(day, saturdayWorks) {
    var wd = day.getUTCDay();
    if (wd === 0) return false;
    if (wd === 6) return saturdayWorks;
    return true;
  }

  function nextWorkday(day, saturdayWorks) {
    var d = addDays(day, 1);
    var guard = 0;
    while (!isWorkday(d, saturdayWorks) && guard++ < 14) d = addDays(d, 1);
    return d;
  }

  function addWorkdays(day, count, saturdayWorks) {
    var d = day;
    for (var i = 0; i < count; i++) d = nextWorkday(d, saturdayWorks);
    return d;
  }

  var DATE_FMT = new Intl.DateTimeFormat("tr-TR", {
    timeZone: "UTC", day: "numeric", month: "long", weekday: "long"
  });
  function formatDay(day) { return DATE_FMT.format(day); }

  /* Aralıkta gün adı yazılmıyor: "26-28 Ağustos Cuma" iki günün de cuma
     olduğunu ima ediyordu. Tek güne düşerse gün adı geri gelir. */
  var RANGE_FMT = new Intl.DateTimeFormat("tr-TR", { timeZone: "UTC", day: "numeric", month: "long" });
  var DAY_ONLY_FMT = new Intl.DateTimeFormat("tr-TR", { timeZone: "UTC", day: "numeric" });
  function formatRange(from, to) {
    if (from.getTime() === to.getTime()) return formatDay(from);
    if (from.getUTCMonth() !== to.getUTCMonth()) {
      return RANGE_FMT.format(from) + " - " + RANGE_FMT.format(to);
    }
    return DAY_ONLY_FMT.format(from) + "-" + RANGE_FMT.format(to);
  }

  function fill(template, value) {
    /* Yer tutucu [time]: locale metni Liquid'den geçtiği için {{ }} kullanılmıyor */
    return String(template || "").replace("[time]", value);
  }

  function countdownText(ms) {
    var totalMinutes = Math.floor(ms / 60000);
    var hours = Math.floor(totalMinutes / 60);
    var minutes = totalMinutes % 60;
    if (hours > 0) return hours + " saat " + minutes + " dk";
    var seconds = Math.floor(ms / 1000) % 60;
    return minutes + " dk " + seconds + " sn";
  }

  function render(root) {
    var minDays = parseInt(root.getAttribute("data-min-days"), 10) || 1;
    var maxDays = parseInt(root.getAttribute("data-max-days"), 10) || minDays;
    var saturdayWorks = root.getAttribute("data-saturday") === "1";
    var today = istanbulToday(new Date());
    var shipDay = nextWorkday(today, saturdayWorks);

    var deliverFrom = addWorkdays(shipDay, minDays, saturdayWorks);
    var deliverTo = addWorkdays(shipDay, maxDays, saturdayWorks);

    var orderEl = root.querySelector("[data-etd-order]");
    var shipEl = root.querySelector("[data-etd-ship]");
    var deliverEl = root.querySelector("[data-etd-deliver]");
    if (orderEl) orderEl.textContent = formatDay(today);
    if (shipEl) shipEl.textContent = formatDay(shipDay);
    if (deliverEl) deliverEl.textContent = formatRange(deliverFrom, deliverTo);

    var lead = root.querySelector("[data-etd-lead]");
    var leadText = root.querySelector("[data-etd-lead-text]");
    if (!lead || !leadText) return;

    leadText.textContent = fill(strings.etdNextShip, formatDay(shipDay) + ", 16:30");
    lead.hidden = false;
  }

  function tick() {
    var roots = document.querySelectorAll("[data-etd]");
    if (!roots.length) {
      if (timer) { clearInterval(timer); timer = null; }
      return;
    }
    roots.forEach(render);
  }

  function init() {
    if (!window.Intl || !Intl.DateTimeFormat) return;
    tick();
    if (!timer) timer = setInterval(tick, 1000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  /* Kardeş ürün geçişi bölümü değiştirince iskelet yeniden doğuyor */
  document.addEventListener("product:section-replaced", tick);
})();
